import React, { useState, useEffect } from 'react';
import TR from './../../Trans';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import settingsStore from '../../stores/settings';
import DeleteDialog from './../dialogs/DeleteDialog';
import sessionStore from '../../stores/session';
import musicPlayerStore from '../../stores/musicPlayer';
import bgPerformanceStore from '../../stores/bgPerformance';
import bgFiltersStore from '../../stores/bgFilters';

function BackgroundMusicBottomBar(props) {

  const sessionToken = sessionStore((state) => state.sessionToken);
  const clearPlayQueue = bgPerformanceStore((state) => state.clearPlayQueue);
  const settings = settingsStore((state) => state.settings);
  const setSettings = settingsStore((state) => state.setSettings);
  const setRepeatPlayList = bgPerformanceStore((state) => state.setRepeatPlayList);
  const clearAllAutoAdded = bgPerformanceStore((state) => state.clearAllAutoAdded);
  const emptyPlayerFilter = bgFiltersStore((state) => state.emptyPlayerFilter);
  const isMusicOn = musicPlayerStore((state) => state.isMusicOn);

  const [isClearDialogOpen, setIsClearDialogOpen] = useState(false);

  const handleOpenClearDialog = () => { 
    setIsClearDialogOpen(true);
  };

  const handleCloseClearDialog = () => { 
    setIsClearDialogOpen(false);
  };

  const onClearing = () => { 
    setRepeatPlayList(null);
    emptyPlayerFilter();
    let newSettings = { ...settings };
    newSettings.music_playlist_id = 0;
    newSettings.music_style_id = 0;
    setSettings(sessionToken, newSettings, false);
    clearAllAutoAdded(sessionToken);
    clearPlayQueue(sessionToken);
    handleCloseClearDialog();
  };

  const renderClear = () => { 
    if(isMusicOn){
      return <Button color="secondary" onClick={handleOpenClearDialog}>{TR.cm_clear}</Button>
    }
  }

  return (
    <Grid container spacing={0}>
      <DeleteDialog
        open={isClearDialogOpen}
        onClose={handleCloseClearDialog}
        onDeletion={onClearing}
        title={TR.cm_are_you_sure}
        cancel={TR.cm_cancel}
        delete={TR.cm_clear}
      />
      <Grid item xs={12} justifyContent="left">
        <Stack className="muvika-playqueue-bottom-bar-stack" direction="row">
          {renderClear()}
        </Stack>
      </Grid>
    </Grid>
  );
}

export default BackgroundMusicBottomBar;